import { is2xxStatus } from "./AlertMessageLogic";

// eslint-disable-next-line
export default function messageOnRemoveInvites(status, info) {
    let message;

    if (is2xxStatus(status)) status = "2xx";

    switch (status) {
        case 503:
            message =
                "Ops! Ocorreu um problema com a internet e não conseguimos desassociar o desenvolvedor.";
            break;
        case "2xx":
            message = "Desassociamos o desenvolvedor do eitri-app.";
            break;
        case 401:
            message =
                "Você não tem autorização para desassociar desenvolvedores deste eitri-app.";
            break;
        default:
            message =
                "Ops! Algo estranho ocorreu e não desassociamos do desenvolvedor do eitri-app. Por favor, tente novamente mais tarde.";
    }

    return message;
}
